import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import MailTemplateEdit from '@/views/mailTemplate/Edit.vue';

export const mailTemplateEditRoute: RouteConfig = {
  path: ':mailTemplateId',
  name: 'mailTemplateEdit',
  component: MailTemplateEdit,
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.mail-templates.edit'
    }
  },
  beforeEnter: (to, from, next) => {
    store.commit('mailTemplate/setId', tryParseInt(to.params.mailTemplateId));
    store.dispatch('mailTemplate/get').then(
      template => {
        mailTemplateEditRoute.meta.breadcrumb.title = template.name;
        next();
      },
      err => store.dispatch('notifyError', { title: 'messages.mailTemplate.getError' })
    );
  }
};
